<template>
  <div class="wt2-enter-comment wt2-modal-inner">
    <div class="-title wt2-text-l2">{{ title }}</div>
    <div v-if="textAreaCaption" class="-message wt2-text-s">
      {{ textAreaCaption }}
    </div>
    <textarea placeholder="Add comment" v-model="message"></textarea>
    <div class="-actions">
      <wt-button
        class="-smaller-font -min-width-unset"
        type="transparent"
        :text="'generic.CANCEL' | culture"
        @click="closeModal"
      ></wt-button>
      <wt-button
        :text="'generic.SEND' | culture"
        @click="done(message)"
      ></wt-button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      message: '',
    };
  },
  props: {
    closeModal: {
      type: Function,
      required: true,
    },
    title: {
      type: String,
      default: '',
    },
    textAreaCaption: {
      type: String,
      default: '',
    },
    done: {
      type: Function,
      required: true,
    },
  },
};
</script>
